var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-swipeout"},[_c('div',{ref:"swipeout",staticClass:"m-swipeout__content",style:(_vm.getStyle),on:{"mousedown":_vm.onButtonDown,"touchstart":_vm.onButtonDown}},[_vm._t("default")],2),_c('div',{ref:"swipeout_button",staticClass:"m-swipeout__button-group",style:(_vm.buttonStyle)},[_vm._t("button")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }